var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('project-actions'),_c('div',{attrs:{"id":"map"},on:{"keydown":function($event){_vm.onkeydown($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }